import React from 'react';
import styles from './modalAccept.module.css';

// icons
import close from '../../assets/x.svg';
import Button from '../Button/Button';

const ModalAccept = ({ document, closeModal, handleDeleteForm }) => {
  return (
    <div className={styles.container}>
      <div style={{ width: '316px' }} />
      <div className={styles.wrapper}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <p className={styles.title}>Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ</p>
          <img src={close} alt="Icon" onClick={closeModal} />
        </div>
        <p className={styles.question}>
          ÐÑ ÑÐ²ÐµÑÐµÐ½Ñ, ÑÑÐ¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ <br />
          <span>{document}</span>
          <br /> Ð±ÐµÐ· Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÐ¸ Ð²Ð¾ÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ?
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <Button text={'ÐÐ°, ÑÐ´Ð°Ð»Ð¸ÑÑ'} fill onClick={handleDeleteForm} />
          <Button text={'ÐÐµÑ, Ð½Ðµ ÑÐ´Ð°Ð»Ð¸ÑÑ'} onClick={closeModal} />
        </div>
      </div>
    </div>
  );
};

export default ModalAccept;
